import ReactDOM from "react-dom/client";
import { createStore } from "redux";
import rootReducer from "./store/reducers/rootReducer";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
// import "./assets/css/livis_theme.scss";
// import "./assets/css/livis_operator_panel.scss";
// import "./assets/css/livis_operator_report.scss";
// import "./assets/css/livis_operator_builder.scss";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
// import './assets/css/global_styles.scss';
import './assets/css/color_palette.scss';
import './assets/css/fonts.scss';
import './assets/css/common_styles.scss';
import './assets/css/vendor_override.scss';
import './modules/inspection-station/styles/inspection-station.scss';
import './modules/inspection-reports/styles/inspection-reports.scss';
import './modules/operator-panel-builder/styles/operator-panel-builder.scss';
import './modules/recipe-builder/styles/recipe-builder.scss';
import './modules/usecase/styles/usecase.scss';
import './modules/part/styles/part.scss';
import './modules/training/styles/training.scss';
import './modules/trash/styles/trash.scss';
import './modules/user/styles/user.scss';
import './modules/tag-management/styles/tag-management.scss';
import './modules/testing/styles/testing.scss';
import './modules/audit-log/styles/audit-log.scss';
import './modules/defect-dataset-library/styles/defect-dataset-library.scss';
import './modules/synthetic-data/styles/synthetic-data.scss';
import './modules/dashboard/styles/dashboard.scss';
import './assets/css/responsive_styles.scss';
import './index.css';
import "./localisation/config";
import App from "./App";
import './modules/archive-settings/styles/archive-settings.scss';
import './modules/storage-configuration/styles/storage-configuration.scss';
import reportWebVitals from "./reportWebVitals";
import { getLivistheme, getLivisBrandColor, getLivisBrandTheme } from "./helpers/storage";
import { initializeTheme } from "./helpers/globalTheme"; // Import the proper function
import { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./localisation/config";
import { initGlobalErrorLogging, initDomTracking, logger } from "./services/logger";
import { DOM_TRACKING_CONFIG } from "./services/logger/domTrackingConfig";
import GlobalErrorBoundary from "./components/ErrorBoundary/GlobalErrorBoundary";

// Wired once, before the first render: crash catchers + DOM interaction
// tracking (clicks, input/select/checkbox changes, form submits, modal
// open/close). See src/services/logger/domTrackingConfig.ts to control
// exactly which of those get logged.
initGlobalErrorLogging();
initDomTracking();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

//debug mode //console.log or can use babel plugin
// if (process.env.NODE_ENV !== "development")
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  //console.log = () => { };

// Remove the old IIFE and use the proper theme initialization
initializeTheme();

const store = createStore(rootReducer);

// Snippet for Debbugging
// const store = createStore(
//   rootReducer,
//   process.env.NODE_ENV === "development"
//     ? (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
//         (window as any).__REDUX_DEVTOOLS_EXTENSION__()
//     : null
// );

root.render(
  <GlobalErrorBoundary>
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
        <Router>
          <App />
        </Router>
      </Provider>
    </I18nextProvider>
  </GlobalErrorBoundary>
);

//It is called reportWebVitals and it measures a set of metrics that aim to capture the user experience of a web page. This set is called web vitals and includes: First Contentful Paint. Largest Contentful Paint.
// Piped into the logger (controlled by DOM_TRACKING_CONFIG.webVitals) —
// previously called with no argument, which is CRA's default no-op.
if (DOM_TRACKING_CONFIG.webVitals) {
  reportWebVitals((metric) => {
    logger.action({
      message: "WEB_VITAL",
      name: metric.name,
      value: metric.value,
      id: metric.id,
    });
  });
}
